/* Carries the page used to open an inquiry. No cookies, storage or requests. */
(function () {
  'use strict';

  function start() {
    var contextNode = document.getElementById('dm-inquiry-page-context');
    if (!contextNode) return;

    var page;
    try {
      page = JSON.parse(contextNode.textContent);
    } catch (error) {
      return;
    }
    if (!page || typeof page !== 'object') return;

    var origin = window.location.origin;
    var parameterNames = [
      'dm_inquiry_source', 'dm_inquiry_title', 'dm_inquiry_product',
      'dm_inquiry_product_url', 'dm_inquiry_variant', 'dm_inquiry_variant_id'
    ];
    var variants = page.product && Array.isArray(page.product.variants) ? page.product.variants : [];
    var variantMap = Object.create(null);
    variants.forEach(function (variant) {
      if (variant && /^\d{1,20}$/.test(String(variant.id))) variantMap[String(variant.id)] = variant;
    });

    function parseUrl(value) {
      if (typeof value !== 'string' || !value || value.length > 3000) return null;
      try {
        var url = new URL(value, window.location.href);
        return /^https?:$/.test(url.protocol) && !url.username && !url.password ? url : null;
      } catch (error) {
        return null;
      }
    }

    function text(value, limit) {
      return typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, limit) : '';
    }

    function path(value) {
      return value.replace(/\/+$/, '') || '/';
    }

    var contactUrl = parseUrl(page.contactPath || '/pages/contact');
    if (!contactUrl || contactUrl.origin !== origin) return;
    var contactPath = path(contactUrl.pathname);
    // Shopify locale prefixes include scripts and numeric regions, for example
    // zh-Hans and es-419. Keep the pattern bounded; arbitrary leading path
    // segments must not make account, app or checkout URLs eligible sources.
    var localePrefix = /^\/[a-z]{2}(?:-[a-z]{4})?(?:-(?:[a-z]{2}|\d{3}))?(?=\/|$)/i;
    var configuredLocale = contactPath.match(/^\/([a-z]{2,3}(?:-[a-z]{4})?(?:-(?:[a-z]{2}|\d{3}))?)\/pages\//i);

    function withoutLocale(pathname) {
      if (configuredLocale) {
        var prefix = '/' + configuredLocale[1].toLowerCase();
        if (pathname.toLowerCase() === prefix || pathname.toLowerCase().indexOf(prefix + '/') === 0) return pathname.slice(prefix.length) || '/';
      }
      return pathname.replace(localePrefix, '') || '/';
    }

    var baseContactPath = path(withoutLocale(contactPath));

    function isContact(url) {
      if (url.origin !== origin) return false;
      var targetPath = path(withoutLocale(url.pathname));
      return targetPath === baseContactPath || targetPath === '/pages/contact';
    }

    function productHandle(url) {
      var match = url && url.pathname.match(/\/products\/([^/]+)\/?$/);
      return match ? match[1] : '';
    }

    // Keep storefront paths only. Never forward search terms, tracking IDs,
    // account/order tokens, hash fragments or arbitrary query parameters.
    function cleanUrl(value, variantId) {
      var url = parseUrl(value);
      if (!url || url.origin !== origin) return null;
      var storefrontPath = /^\/(?:products|collections|pages|blogs|policies)(?:\/|$)/i;
      var pathname = withoutLocale(url.pathname);
      if (!storefrontPath.test(pathname) && pathname !== '/' && !/^\/search\/?$/i.test(pathname)) return null;
      url.search = '';
      url.hash = '';
      if (productHandle(url) && /^\d{1,20}$/.test(String(variantId || ''))) url.searchParams.set('variant', String(variantId));
      return url;
    }

    var currentUrl = cleanUrl(window.location.href);
    var canonicalProduct = page.product && cleanUrl(page.product.url);
    var isProduct = !!(page.pageType === 'product' && currentUrl && canonicalProduct && productHandle(currentUrl) && productHandle(currentUrl) === productHandle(canonicalProduct));
    var onContactPage = currentUrl && isContact(currentUrl);

    function selectedVariant() {
      if (!isProduct) return null;
      var urlVariant = new URL(window.location.href).searchParams.get('variant');
      var excluded = 'quick-add-modal, quick-add-drawer, quick-buy-drawer, quick-buy-modal, quick-view, product-recommendations, [id*="QuickAdd"], [id^="quick-buy"], [id^="quick-buy-form-"], [class*="quick-add"], [class*="quick-view"]';

      function formVariantId(form) {
        if (!form || (form.tagName && form.tagName.toLowerCase() !== 'form')) return '';
        var action = parseUrl(form.getAttribute('action'));
        if (!action || action.origin !== origin || !/\/cart\/add\/?$/.test(action.pathname)) return '';
        if (form.closest(excluded) || /(?:installment|payment)/i.test(form.id || '') || /(?:installment|payment)-form/i.test(form.className || '') || form.getAttribute('data-type') === 'installment') return '';
        var productId = form.querySelector('[name="product-id"]');
        if (productId && String(productId.value) !== String(page.product.id)) return '';
        var input = form.querySelector('[name="id"]:checked, select[name="id"], input[name="id"]');
        var id = input && String(input.value);
        return id && variantMap[id] ? id : '';
      }

      function uniqueVariant(ids) {
        var distinct = ids.filter(function (id, index) { return ids.indexOf(id) === index; });
        return distinct.length === 1 ? variantMap[distinct[0]] : null;
      }

      // Impact points product-rerender directly at its authoritative add-to-cart
      // form. Its installment form can still contain the previous variant ID.
      var observedIds = [];
      document.querySelectorAll('product-rerender[observe-form]').forEach(function (rerender) {
        if (rerender.closest(excluded)) return;
        var form = document.getElementById(rerender.getAttribute('observe-form'));
        var id = formVariantId(form);
        if (id) observedIds.push(id);
      });
      var observedVariant = uniqueVariant(observedIds);
      if (observedVariant) return observedVariant;

      var formIds = [];
      var mainIds = [];
      document.querySelectorAll('form[action]').forEach(function (form) {
        var id = formVariantId(form);
        if (!id) return;
        formIds.push(id);
        if (/^product-form-/.test(form.id || '') || form.closest('product-info, .product-info, [id^="ProductInfo-"], [id^="MainProduct-"]')) mainIds.push(id);
      });
      // Read the main form at interaction time: themes may update it before
      // changing the URL. Only IDs from this page's product are accepted.
      var ids = mainIds.length ? mainIds : formIds;
      var formVariant = uniqueVariant(ids);
      if (formVariant) return formVariant;
      if (urlVariant && variantMap[urlVariant]) return variantMap[urlVariant];
      return null;
    }

    function currentContext(method) {
      if (!currentUrl || onContactPage) return null;
      var variant = selectedVariant();
      var variantId = variant ? String(variant.id) : '';
      var source = cleanUrl(window.location.href, variantId);
      if (!source) return null;
      return {
        source_url: source.href,
        source_title: text(page.pageTitle, 240),
        product_name: isProduct ? text(page.product.title, 240) : '',
        product_url: isProduct ? cleanUrl(canonicalProduct.href, variantId).href : '',
        variant: variant ? text(variant.title || (Array.isArray(variant.options) ? variant.options.join(' / ') : ''), 240) + ' (ID: ' + variantId + ')' : '',
        variant_id: variantId,
        variant_title: variant ? text(variant.title || (Array.isArray(variant.options) ? variant.options.join(' / ') : ''), 240) : '',
        source_method: method
      };
    }

    function referrerUrl() {
      var referrer = parseUrl(document.referrer);
      if (!referrer) return '';
      if (referrer.origin !== origin) return referrer.origin;
      var clean = cleanUrl(referrer.href);
      return clean ? clean.href : '';
    }

    function formContext() {
      var direct = !onContactPage && currentContext(isProduct ? 'Direct product form' : 'Current page form');
      if (direct) return direct;

      var result = {
        source_url: '', source_title: '', product_name: '', product_url: '',
        variant: '', source_method: 'Unknown'
      };
      var params = new URL(window.location.href).searchParams;
      var source = cleanUrl(params.get('dm_inquiry_source'));
      if (source && !isContact(source)) {
        result.source_url = source.href;
        result.source_title = text(params.get('dm_inquiry_title'), 240);
        result.source_method = 'Link click';
        var product = cleanUrl(params.get('dm_inquiry_product_url'));
        // Product details are accepted only with an explicit matching product
        // URL. A referrer alone must never be presented as a known product.
        if (product && productHandle(source) && productHandle(product) === productHandle(source)) {
          result.product_name = text(params.get('dm_inquiry_product'), 240);
          var variantId = params.get('dm_inquiry_variant_id') || '';
          if (/^\d{1,20}$/.test(variantId)) {
            result.source_url = cleanUrl(source.href, variantId).href;
            result.product_url = cleanUrl(product.href, variantId).href;
            result.variant = text(params.get('dm_inquiry_variant'), 240) + ' (ID: ' + variantId + ')';
          } else {
            result.product_url = product.href;
          }
        }
        return result;
      }

      var referrer = referrerUrl();
      if (referrer) {
        var previous = parseUrl(referrer);
        if (previous.origin === origin && !isContact(previous) && (!currentUrl || previous.pathname !== currentUrl.pathname)) {
          result.source_url = referrer;
          result.source_method = 'Referrer fallback (page only)';
        } else if (previous.origin !== origin) {
          result.source_method = 'Referrer fallback (external origin only)';
        }
      }
      return result;
    }

    function fillFields() {
      var fields = document.querySelectorAll('input[type="hidden"][data-dm-inquiry-field]');
      if (!fields.length) return;
      var values = formContext();
      values.referrer = referrerUrl();
      values.submission_url = currentUrl ? currentUrl.href : '';
      fields.forEach(function (field) {
        var form = field.closest('form');
        if (!form || !form.querySelector('input[name="form_type"][value="contact"]')) return;
        var key = field.getAttribute('data-dm-inquiry-field');
        if (Object.prototype.hasOwnProperty.call(values, key)) field.value = values[key];
      });
    }

    function updateLink(link, values) {
      if (!values || !link || link.hasAttribute('download')) return;
      var target = parseUrl(link.getAttribute('href'));
      if (!target || !isContact(target)) return;
      parameterNames.forEach(function (name) { target.searchParams.delete(name); });
      target.searchParams.set('dm_inquiry_source', values.source_url);
      if (values.source_title) target.searchParams.set('dm_inquiry_title', values.source_title);
      if (values.product_name) target.searchParams.set('dm_inquiry_product', values.product_name);
      if (values.product_url) target.searchParams.set('dm_inquiry_product_url', values.product_url);
      if (values.variant_id) target.searchParams.set('dm_inquiry_variant_id', values.variant_id);
      if (values.variant_title) target.searchParams.set('dm_inquiry_variant', values.variant_title);
      if (link.href !== target.href) link.setAttribute('href', target.href);
    }

    function refresh() {
      var values = currentContext('Link click');
      if (values) document.querySelectorAll('a[href]').forEach(function (link) { updateLink(link, values); });
      fillFields();
    }

    // Prepare URLs before a new-tab/context-menu action as well as regular
    // clicks. Never prevent navigation, alter a message or submit a form.
    ['pointerdown', 'mousedown', 'click', 'auxclick', 'contextmenu', 'focusin'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        var target = event.target && event.target.closest ? event.target.closest('a[href]') : null;
        if (target) updateLink(target, currentContext('Link click'));
      }, true);
    });
    document.addEventListener('change', function () { window.setTimeout(refresh, 0); }, true);
    window.addEventListener('pageshow', refresh);
    window.addEventListener('popstate', refresh);

    var queued = false;
    if (window.MutationObserver && document.body) {
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        window.setTimeout(function () { queued = false; refresh(); }, 0);
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    }
    refresh();
  }

  // A missing/malformed context must not interfere with the storefront.
  function safeStart() {
    try { start(); } catch (error) { /* Inquiry context is optional. */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', safeStart, { once: true });
  else safeStart();
}());
